module.exports = __webpack_public_path__ + "img/ic_position.7d39120e.svg";